import React, {useEffect} from 'react';
import {Alert} from 'reactstrap';
import RequestList from '../Request/RequestsList';
import {Link} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {userData} from "../../recoil_store";
import {initGDriveCall} from "../../services/gDrive.service";
import {roles} from "../../constants";

const Dashboard = () => {
    const {subscriptions} = useRecoilValue(userData);
    const isFreeTier = !!subscriptions && !!subscriptions.freeTier;
    const isPlanExpired = !!subscriptions && !subscriptions.validPlanLimit;

    useEffect(() => {
        intiGDrive();
    }, [])

    const intiGDrive = async () => {
        try {
          if (localStorage.accessToken && localStorage.role === roles.USER) {
            await initGDriveCall();
          }
        } catch (err) {
            // message.error('Failed to load your google drive account');
        }
    }

    return (
        <div className="dashboard">
            {
                (isFreeTier || isPlanExpired) && <Alert color="warning">
                    {isFreeTier ? 'You are using free tier' : 'You have reached the limit of current subscription'}, go
                    to <Link to="/payment">Payment</Link> page and
                    upgrade subscription to use features of website.
                </Alert>
            }
            <RequestList/>
        </div>
    )
};

export default Dashboard;
